/**
 * Computes server-side wall-clock duration (ms) for a Blaxel process response
 * from its `startedAt` / `completedAt` ISO timestamps. Returns `null` when
 * either timestamp is missing, unparseable, or non-monotonic — callers should
 * treat that as "server timing unavailable" and fall back to the client-side
 * measurement on `phaseDurations`.
 *
 * Shared by `buildCodeLibrary.ts` and `scanImports.ts` so the two call sites
 * can't drift on how bad timestamps are handled (e.g. if one later starts
 * logging the null case and the other doesn't).
 */
export function execDurationMs(response: {
  startedAt: string;
  completedAt: string;
}): number | null {
  const start = new Date(response.startedAt).getTime();
  const end = new Date(response.completedAt).getTime();
  if (!Number.isFinite(start) || !Number.isFinite(end) || end < start) {
    return null;
  }
  return end - start;
}
